import { render, staticRenderFns } from "./ReasonForReturn.vue?vue&type=template&id=2909fc0f&scoped=true"
import script from "./ReasonForReturn.vue?vue&type=script&lang=js"
export * from "./ReasonForReturn.vue?vue&type=script&lang=js"
import style0 from "./ReasonForReturn.vue?vue&type=style&index=0&id=2909fc0f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2909fc0f",
  null
  
)

export default component.exports